import React from 'react';
import { useTranslation } from 'react-i18next';
import RecentTradesTable from '../tables/RecentTradesTable';

const TradesPage = ({ trades }) => {
  const { t } = useTranslation();

  return (
    <div className="content-section">
      <h2>{t('recentTrades.title')}</h2>
      <div className="trades-section">
        <RecentTradesTable trades={trades} />
      </div>
    </div>
  );
};

export default TradesPage;
